import { FC } from "react";

import IAQTabTemplate from "../Template";

type FieldErrors = { co2?: string; hcho?: string; tvoc?: string };

type PropTypes = {
  co2: number;
  hcho: number;
  tvoc: number;
  errors?: FieldErrors;
  handleFieldChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const ThresholdLimit: FC<PropTypes> = ({ co2, hcho, tvoc, errors, handleFieldChange }) => {
  return (
    <IAQTabTemplate
      infoDescription="TLV-C - Threshold Limit Value (Ceiling): The maximum concentration that should never be exceeded, even momentarily. Alert triggers instantly on a single reading. No averaging period."
      pmDescription="According to DM-HSD-GU119, there is no instant threshold limit for PM2.5 and PM10. No alerts are triggered based on instant readings."
      handleFieldChange={handleFieldChange}
      gasFields={[
        { label: "CO₂", unit: "ppm", hint: "Def: 5000 ppm", value: co2, name: "thresholdLimit.co2", error: errors?.co2 },
        { label: "HCHO", unit: "ppm", hint: "Def: 1 ppm", value: hcho, name: "thresholdLimit.hcho", error: errors?.hcho },
        { label: "TVOC", unit: "ppm", hint: "Def: 5.5 ppm", value: tvoc, name: "thresholdLimit.tvoc", error: errors?.tvoc },
      ]}
      pmFields={[
        { label: "PM2.5", unit: "µg/m³", hint: "No threshold limit" },
        { label: "PM10", unit: "µg/m³", hint: "No threshold limit" },
      ]}
    />
  );
};

export default ThresholdLimit;
